import { createSelector } from 'reselect';
import { SITES } from '../constants/site.constants';
import { initialState } from '../reducers/site.reducer';

const selectState = state => state[SITES] || initialState;

export const selectSites = () => createSelector(selectState, state => state.get('data').toList());
export const selectSelectedSite = () => createSelector(selectState, state => state.get('selectedSite'));